import React from "react";

const Footer = () => {
  return (
    <div className="bg-[#111d42] border-t border-white/10 w-full">
      <footer className="w-[90%] mx-auto py-5">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="text-sm text-white/40">
            © {new Date().getFullYear()} Martech Mastery. All rights reserved.
          </div>
          <div
            className="text-sm text-[#F05A22] hover:text-[#f47244] cursor-pointer underline underline-offset-2 transition-colors"
            onClick={() => window.open('https://www.oadsolutions.com/privacy-policy', '_blank')}
          >
            Privacy Policy
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
